var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"img",attrs:{"src":_vm.src,"lazy-src":_vm.src,"cover":_vm.cover,"transition":_vm.transition,"gradient":_vm.gradient}})}
var staticRenderFns = []

export { render, staticRenderFns }